import React from 'react';
import { Box } from '@landr/maestro';

export const PlaceholderButton: React.FC = () => {
    return (
        <Box width="36px" height="36px" data-testid={'placeholder-button'} />
    );
};
